import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=12571ffe&scoped=true"
import script from "./SearchPanel.vue?vue&type=script&lang=js"
export * from "./SearchPanel.vue?vue&type=script&lang=js"
import style0 from "./SearchPanel.vue?vue&type=style&index=0&id=12571ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12571ffe",
  null
  
)

export default component.exports